import Instruction from 'entities/instruction/Instruction';

export type ColorMapEntry = {
    name: string;
    hex: number;
};

const ColorMap: { [key: string]: ColorMapEntry } = {
    [Instruction.COLOR_RED]: {
        name: 'red',
        hex: 0xff0000,
    },
    [Instruction.COLOR_ORANGE]: {
        name: 'orange',
        hex: 0xffa500,
    },
    [Instruction.COLOR_YELLOW]: {
        name: 'yellow',
        hex: 0xffff00,
    },
    [Instruction.COLOR_GREEN]: {
        name: 'green',
        hex: 0x00ff00,
    },
    [Instruction.COLOR_BLUE]: {
        name: 'blue',
        hex: 0x0000ff,
    },
    [Instruction.COLOR_PURPLE]: {
        name: 'purple',
        hex: 0xff00ff,
    },
    [Instruction.COLOR_BLACK]: {
        name: 'black',
        hex: 0x000000,
    },
};

export default ColorMap;
